import Vue from 'vue'
import Router from 'vue-router'
import ApplicationLayout from '@/views/layouts/ApplicationLayout'
// PARA RODAR NO LOCAL
// import InvestorLayoutDesign from '@/views/layouts/InvestorLayoutDesign'
import InvestorLayout from '@/views/layouts/InvestorLayout'
// import NewInvestorLayout from '@/views/layouts/NewInvestorLayout'
import LoansLayout from '@/views/layouts/LoansLayout'
import PartnersLayout from '@/views/layouts/PartnersLayout'
import LoanAlerts from '@/views/layouts/LoanAlerts'
import BlankLayout from '@/views/layouts/BlankLayout'
import LandingPageLayout from '@/views/layouts/LandingPage'

// import Home from '@/views/Home'
import NotFound from '@/views/NotFound'
import Login from '@/views/Login'
import NovoCadastroUsuario from '@/views/NovoCadastroUsuario'
//import LoginPreview from '@/views/LoginPreview'
import CriarConta from '@/views/CriarConta'
import CriarContaConvidado from '@/views/CriarContaConvidado'
import CriarSenha from '@/views/CriarContaSenha'
import EmailConfirmation from '@/views/EmailConfirmation'
import CadastrarSenha from '@/views/CadastrarSenha'
import CadastrarSenhaUsuario from '@/views/CadastrarSenhaUsuario'
import RecuperarSenha from '@/views/RecuperarSenha'
import NovaSenha from '@/views/NovaSenha'
import OauthCallback from '@/components/OauthCallback'
import AdditionalInformationLayout from '@/views/layouts/AdditionalInformationLayout'
import AdditionalLoansLayout from '@/views/layouts/AdditionalLoansLayout'
import AdditionalInformationPeerToPeer from '@/views/AdditionalInformationPeerToPeer'
//import AdditionalInformationPeerToPeerBeta from '@/views/AdditionalInformationPeerToPeerBeta'
import AdditionalInformationPersonalLoan from '@/views/AdditionalInformationPersonalLoan'
import AdditionalInformationContrucao from '@/views/AdditionalInformationConstrucao'
import AdditionalInformationInvestor from '@/views/AdditionalInformationInvestor'
import InformationSuitability from '@/views/InformationSuitability'
import InformationSuitabilityVerify from '@/views/InformationSuitabilityVerify'
import OpportunitiesLayout from '@/views/layouts/OpportunitiesLayout'
import SolicitacaoAnalise from '@/views/SolicitacaoAnalise'
import SolicitacaoNegada from '@/views/SolicitacaoNegada'
import SelectLoan from '@/views/SelectLoanType'
import Simulation from '@/views/Simulation'
import LoanSimulation from '@/views/LoanSimulation'
import LoanSolicitationBeta from '@/views/LoanSolicitationBeta'
//import Loans from '@/views/Loans'
import SelectArea from '@/views/SelectArea'
// import InviteFriend from '@/views/InviteFriend'
import AdditionalInformationSocial from '@/views/AdditionalInformationSocial'

// TEMPLATES INVESTIDORES
import HomeInvestor from '@/views/HomeInvestor'
import ListOpportunities from '@/views/ListOpportunities'
import ListAntecipationReceivables from '@/views/ListAntecipationReceivables'
import ListHistoric from '@/views/ListHistoric'
import HistoricProfile from '@/views/HistoricProfile'
import ListImpact from '@/views/ListImpact'
import ImpactProfile from '@/views/ImpactProfile'
import EmprestimoSocialNew from '@/views/EmprestimoSocialNew'
import Checkout from '@/views/Checkout'
import CompanyProfile from '@/views/CompanyProfile'
import CompanyProfileOld from '@/views/CompanyProfileOld'
import CCBProfile from '@/views/CCBProfile'
import CCBInvestor from '@/views/CCBInvestor'
import ConfirmCadastroInvestor from '@/views/ConfirmCadastroInvestor'


import CCBList from '@/views/CCBList'
import CCBLoan from '@/views/CCBLoan'
import CCBResponse from '@/views/CCBResponse'
// import InvestorWallet from '@/views/InvestorWallet'
import FinishInvestment from '@/views/FinishInvestment'

// TEMPLATES EMPRESTIMOS
// import HomeLoans from '@/views/HomeLoans'
import MyLoansLayout from '@/views/layouts/MyLoansLayout'
import MyLoans from '@/views/MyLoans'

import PreApproved from '@/views/Preapproved'
import PreApprovedDetails from '@/views/PreapprovedDetails'


import DetailsLoans from '@/views/DetailsLoans'
import AllTickets from '@/views/AllTickets'

// TEMPLATES DE PERFIL
import Profile from '@/views/Profile'
import ProfileConf from '@/views/ProfileConf'
import ProfileNotific from '@/views/ProfileNotific'
import ProfileDocs from '@/views/ProfileDocs'
import ProfileHist from '@/views/ProfileHist'
import ProfileEdit from '@/views/ProfileEdit'
import Documentos from '@/views/Documentos'
import Notificacoes from '@/views/Notifications'

// TEMPLATES WALLET
import Wallet from '@/views/Wallet/Wallet.vue'
import WalletHistoric from '@/views/Wallet/WalletHistorico.vue'
import FundsTransfer from '@/views/WalletFundsTransfer'
import WalletReceipt from '@/views/WalletReceipt'
import WalletPagamento from '@/views/WalletPagamento'
import WalletAddCash from '@/views/WalletAddCash'

// TEMPLATES STATISTICS
import Statistics from '@/views/Statistics'
import StatisticsHome from '@/views/StatisticsHome'
import StatisticsPlatform from '@/views/StatisticsPlatform'
import StatisticsInvestor from '@/views/StatisticsInvestor'
import StatisticsLoan from '@/views/StatisticsLoan'

// DARF
import Darf from '@/views/Darf'

// CENTRAL DE COBRANÇA
import CentralCobranca from '@/views/CentralCobranca'
import CentralCobrancaView from '@/views/CentralCobrancaView'

//Leads
import LeadLoansLayout from '@/views/layouts/LeadLoansLayout'
import ConfirmCadastroLead from '@/views/ConfirmCadastroLead'
import CriarContaLead from '@/views/CriarContaLead'

//Em Construção
import EmConstrucao from '@/views/EmConstrucao'

// Landing Pages
import LandingPageInvista from '@/views/LandingPageInvista'
import LandingPageInvistaIouu from '@/views/LandingPageInvistaIouu'

import ReportYield from '@/views/ReportYield'

/**
 * New Page Login
 */
import NewLogin from '@/views/NewLogin.vue'

Vue.use(Router)

const router = new Router({
    routes: [
        // {
        //     path: '/login',
        //     name: 'Login',
        //     component: Login,
        //     meta: { onlyNotAuthenticated: true }
        // },
        {
            path: '/login',
            name: 'NewLogin',
            component: NewLogin,
        },
        {
            path: '/escolher-conta',
            name: 'EscolherConta',
            component: CriarConta,
            meta: { onlyNotAuthenticated: true }
        },
        /*{
            path: '/LoginPreview/:id',
            name: 'LoginPreview',
            component: LoginPreview,
        },*/
        {
            path: '/criar-conta',
            name: 'CriarConta',
            component: NovoCadastroUsuario,
            meta: { onlyNotAuthenticated: true }
        },
        {
            path: '/criar-senha',
            name: 'CriarSenha',
            component: CriarSenha,
            meta: { onlyNotAuthenticated: true }
        },
        {
            path: '/criar-conta/ref/:id',
            name: 'Criar conta convidado',
            component: CriarContaConvidado,
            meta: {onlyNotAuthenticated: true}
        },
        {
            path: '/criar-conta-lead/',
            name: 'Criar conta lead',
            component: CriarContaLead,
            meta: {onlyNotAuthenticated: true}
        },
        {
            path: '/landing-page/invista-com-alta-rentabilidade',
            component: LandingPageLayout,
            meta: {onlyNotAuthenticated: true},
            children : [
                {
                    path: '',
                    name: 'Invista com alta rentabilidade',
                    component: LandingPageInvista
                }
            ]
        },
        {
            path: '/landing-page/seja-um-investidor-iouu',
            component: LandingPageLayout,
            meta: {onlyNotAuthenticated: true},
            children : [
                {
                    path: '',
                    name: 'Seja um investidor IOUU',
                    component: LandingPageInvistaIouu
                }
            ]
        },
        {
            path: '/call/serasa',
            name: 'Serasa',
            component: LeadLoansLayout,
            meta: {onlyNotAuthenticated: true},
            children: [
                {
                    path: '',
                    name: 'Lead Confirm',
                    component: ConfirmCadastroLead
                }
            ]
        },
        {
            path: '/confirmacao-email',
            name: 'EmailConfirmation',
            component: EmailConfirmation
        },
        {
            path: '/confirmacao-ccb/:id',
            component: AdditionalInformationLayout,
            children: [{
                path: '',
                name: 'CCBConfirmation',
                component: CCBResponse
            }]

        },
        {
            path: '/cadastro-concluido-com-sucesso',
            component: AdditionalInformationLayout,
            children: [{
                path: '',
                name: 'CadastroUserConcluidoInvestidor',
                component: ConfirmCadastroInvestor
            }]

        },
        {
            path: '/cadastrar-senha',
            name: 'CadastrarSenha',
            component: CadastrarSenha
        },
        {
            path: '/cadastrar-senha-do-usuario',
            name: 'CadastrarSenhaUsuario',
            component: CadastrarSenhaUsuario
        },
        {
            path: '/recuperar-senha',
            name: 'RecuperarSenha',
            component: RecuperarSenha
        },
        {
            path: '/nova-senha',
            name: 'NovaSenha',
            component: NovaSenha
        },
        {
            path: '/oauth/:provider/callback',
            name: 'OauthCallback',
            component: OauthCallback
        },
        {
            path: 'estatisticas',
            name: 'Estatísticas',
            component: EmConstrucao
        },
        {
            path: 'perguntas-respostas',
            name: 'PerguntaseRespostas',
            component: EmConstrucao
        },
        {
            path: '/carteira-investimento',
            nome: 'Carteira de Investimento',
            component: EmConstrucao
        },
        {
            path: '/informacoes-adicionais', // INFORMAÇÕES ADCIONAIS PARA EMPRESTIMOS
            component: AdditionalLoansLayout,
            meta: { onlyAuthenticated: true },
            children: [{
                    path: 'selecionar-area',
                    component: SelectArea
                },
                {
                    path: 'emprestimo-pessoal/:id',
                    component: AdditionalInformationPersonalLoan, //AdditionalInformationContrucao (testar em desenv 1.0.19),
                    meta: { onlyAuthenticated: true }
                },
                {
                    path: 'emprestimo-coletivo/:id',
                    component: AdditionalInformationPeerToPeer,
                    meta: { onlyAuthenticated: true }
                },
                {
                    path: 'emprestimo-de-impacto2/:id',
                    component: AdditionalInformationPeerToPeer,
                    meta: { onlyAuthenticated: true }
                },
                {
                    path: 'emprestimo-de-impacto/:id',
                    component: AdditionalInformationPeerToPeer,
                    meta: { onlyAuthenticated: true }
                },
                {
                    path: 'emprestimo-social/:id',
                    component: AdditionalInformationSocial,
                    meta: { onlyAuthenticated: true }
                },
                {
                    path: 'imovel-em-garantia/:id',
                    component: AdditionalInformationContrucao
                },
                {
                    path: 'veiculo-em-garantia/:id',
                    component: AdditionalInformationContrucao
                },
            ]
        },
        {
            path: '/informacoes-adicionais', // INFORMAÇÕES ADCIONAIS PARA INVESTIDORES
            component: AdditionalInformationLayout,
            meta: { onlyAuthenticated: true },
            children: [{
                    path: 'selecionar-area',
                    component: SelectArea,
                    meta: { onlyAuthenticated: true }
                },
                {
                    path: 'investidor',
                    component: AdditionalInformationInvestor,
                    meta: { onlyAuthenticated: true }
                },
                {
                    path: 'suitabilityVerify',
                    component: InformationSuitabilityVerify,
                    meta: { onlyAuthenticated: true }
                },
                {
                    path: 'suitability',
                    component: InformationSuitability,
                    meta: { onlyAuthenticated: true }
                }
            ]
        },
        {
            path: '/darf/:id/:idINV',
            component: BlankLayout,
            children: [{
                name: "DARF",
                path: '',
                component: Darf
            }]
        },
        {
            path: '/informe-rendimento',
            component: ReportYield,
            meta: { onlyAuthenticated: true }
        },
        {
            path: '/investimentos',
            component: InvestorLayout,
            meta: { onlyAuthenticated: true },
            children: [
                {
                    path: 'meus-investimentos',
                    name: 'Investimentos',
                    component: HomeInvestor,
                    meta: { onlyAuthenticated: true },
                },
                {
                    path: 'investimento-de-impacto',
                    component: OpportunitiesLayout,
                    children: [{
                            name: 'InvestimentodeImpacto',
                            path: '',
                            component: ListImpact
                        },
                        {
                            path: 'perfil-impacto/:id',
                            name: 'Impacto',
                            component: ImpactProfile
                        },
                        {
                            path: 'perfil-social-new/:id',
                            name: 'Social',
                            component: EmprestimoSocialNew
                        }
                    ]
                },
                // {
                //     name: 'Convidar amigo',
                //     path: 'convidar-amigo',
                //     component: InviteFriend,
                //     meta: { onlyAuthenticated: true }
                // },
                {
                    path: 'portfolios',
                    name: 'Portfólios',
                    component: EmConstrucao
                },
                {
                    path: 'historico',
                    component: OpportunitiesLayout,
                    children: [{
                            name: 'Histórico',
                            path: '',
                            component: ListHistoric
                        },
                        {
                            name: 'HistoricoInvestimento',
                            path: 'historico-de-investimento/:id',
                            component: HistoricProfile
                        }
                    ]
                },
                // Descomentar central de cobranca
                {
                    path: 'central-de-cobranca',
                    component: OpportunitiesLayout,
                    children: [
                        {
                            name: 'Central de Cobrança',
                            path: '',
                            component: CentralCobranca
                        },
                        {
                            name: 'VisualizarStatusCobranca',
                            path: 'status-cobranca',
                            component: CentralCobrancaView
                        }
                    ]
                },
                {
                    path: 'perguntas-respostas',
                    name: 'PerguntaseRespostasInv',
                    component: EmConstrucao
                },
                {
                    path: 'oportunidades',
                    component: OpportunitiesLayout,
                    children: [{
                            name: 'Oportunidades',
                            path: '',
                            component: ListOpportunities
                        },
                        {
                            path: 'confirmacao/:id',
                            name: 'Checkout',
                            component: Checkout,
                            meta: { onlyAuthenticated: true }
                        },
                        {
                            path: 'perfil-empresa/:id',
                            name: 'Empresa novo',
                            component: CompanyProfile,
                            meta: { onlyAuthenticated: true }
                        },
                        {
                            path: 'perfil-empresa-old/:id',
                            name: 'Empresa',
                            component: CompanyProfileOld,
                            meta: { onlyAuthenticated: true }
                        },
                        {
                            path: ':id/perfil-ccb',
                            name: 'CCB',
                            component: CCBProfile
                        }
                    ]
                },
                {
                    path: 'antecipacao',
                    component: OpportunitiesLayout,
                    children: [{
                            name: 'Antecipacao',
                            path: '',
                            component: ListAntecipationReceivables
                        },
                        {
                            path: 'confirmacao/:id',
                            name: 'Checkout',
                            component: Checkout,
                            meta: { onlyAuthenticated: true }
                        },
                        {
                            path: 'perfil-empresa/:id',
                            name: 'Empresa novo',
                            component: CompanyProfile,
                            meta: { onlyAuthenticated: true }
                        },
                        {
                            path: 'perfil-empresa-old/:id',
                            name: 'Empresa',
                            component: CompanyProfileOld,
                            meta: { onlyAuthenticated: true }
                        },
                        {
                            path: ':id/perfil-ccb',
                            name: 'CCB',
                            component: CCBProfile
                        }
                    ]
                },
                {
                    path: 'estatisticas',
                    component: OpportunitiesLayout,
                    children: [{
                            name: 'Estatisticas',
                            path: '',
                            component: Statistics,
                            children: [{
                                path: '',
                                component: StatisticsHome
                            }]
                        },
                        {
                            path: 'estatisticas-da-plataforma',
                            component: Statistics,
                            children: [{
                                path: '',
                                component: StatisticsPlatform,

                                children: [{
                                    path: 'investidores',
                                    component: StatisticsInvestor
                                }, {
                                    path: 'emprestimos',
                                    component: StatisticsLoan
                                }]
                            }]
                        }
                    ]
                },
                {
                    path: 'carteira-investimento',
                    component: OpportunitiesLayout,
                    children: [{
                            name: 'CarteiraInvestimento',
                            path: '',
                            component: Wallet
                        },
                        {
                            path: 'historico',
                            name: 'WalletHistorico',
                            component: WalletHistoric
                        },
                        {
                            path: 'transferir-fundos',
                            name: 'Transferencia',
                            component: FundsTransfer
                        },
                        {
                            path: 'comprovante/:id',
                            name: 'Comprovante',
                            component: WalletReceipt
                        },
                        {
                            path: 'comprovante/pagamento/:id',
                            name: 'ComprovantePagamento',
                            component: WalletPagamento
                        },
                        {
                            path: 'adicionar-fundos',
                            name: 'AdicionarFundos',
                            component: WalletAddCash
                        }
                    ]
                },
                {
                    path: 'finalizar-investimento',
                    nome: 'Finalizar investimentos',
                    component: FinishInvestment
                },
                {
                    path: 'perfil',
                    name: 'Perfil',
                    component: Profile,
                    children: [{
                            path: 'dados-pessoais',
                            name: 'Dados Pessoais',
                            component: ProfileConf
                        },
                        {
                            path: 'editar-perfil',
                            name: 'Editar',
                            component: ProfileEdit
                        },
                        {
                            path: 'configuracoes',
                            name: 'Configuracoes',
                            component: ProfileNotific
                        },
                        {
                            path: 'documentos',
                            name: 'Documentos',
                            component: ProfileDocs
                        },
                        {
                            path: 'historico',
                            name: 'Profile Histórico',
                            component: ProfileHist
                        }
                    ]
                },
                {
                    path: 'minhas-ccbs',
                    component: OpportunitiesLayout,
                    meta: { onlyAuthenticated: true },
                    children: [{
                            path: '',
                            name: 'MinhasCCBS',
                            meta: { onlyAuthenticated: true },
                            component: CCBList
                        },
                        {
                            path: 'formalizar/:id',
                            meta: { onlyAuthenticated: true },
                            name: 'FormalizarCCB',
                            component: CCBInvestor

                        }
                    ]
                },
                {
                    path: 'documentos',
                    name: 'docsINV',
                    meta: { onlyAuthenticated: true },
                    component: Documentos
                },
                {
                    path: 'atendimento',
                    name: 'Atendimento',
                    component: EmConstrucao
                },
                {
                    path: 'notificacoes',
                    name: 'Notificações Investidor',
                    component: Notificacoes
                },

            ]
        },
        {
            path: '/emprestimos',
            component: LoansLayout,
            children: [{
                path: '',
                component: MyLoansLayout,
                children: [{
                        name: 'Meus Emprestimos',
                        path: 'meus-emprestimos',
                        component: MyLoans,
                        meta: { onlyAuthenticated: true }
                    },
                    {
                        path: 'pre-aprovado-detalhes',
                        component: PreApprovedDetails
                    }, {

                        name: 'Pré Aprovado',
                        path: "pre-aprovado",
                        component: PreApproved

                    },
                    {
                        path: 'detalhes-do-emprestimo',
                        name: 'Detalhes do empréstimo',
                        meta: { onlyAuthenticated: true },
                        component: DetailsLoans
                    },
                    {
                        path: 'formalizar-ccb/:id',
                        meta: { onlyAuthenticated: true },
                        component: CCBLoan
                    },
                    {
                        path: 'boletos',
                        name: 'Todos os Boletos',
                        component: AllTickets
                    },
                    {
                        path: 'solicitar-emprestimo',
                        name: 'Solicitar Empréstimo',
                        component: EmConstrucao
                    },
                    {
                        path: 'historico',
                        name: 'Histórico Empréstimo',
                        component: EmConstrucao
                    },
                    {
                        path: 'perfil',
                        name: 'PerfilEMP',
                        component: Profile,
                        children: [{
                                path: 'dados-pessoais',
                                name: 'Dados Pesssoais EMP',
                                component: ProfileConf
                            },
                            {
                                path: 'configuracoes',
                                name: 'Configuracoes EMP',
                                component: EmConstrucao
                            },
                            {
                                path: 'documentos',
                                name: 'Documentos EMP',
                                component: ProfileDocs
                            },
                            {
                                path: 'historico',
                                name: 'Profile Histórico EMP',
                                component: ProfileHist
                            }
                        ]
                    },
                    {
                        path: 'documentos',
                        name: 'docs',
                        meta: { onlyAuthenticated: true },
                        component: Documentos
                    },
                    {
                        path: 'notificacoes',
                        name: 'Notificações Emprestimo',
                        component: Notificacoes
                    }
                ]
            }]
        },
        {
            path: '/solicitacao-em-analise',
            component: LoanAlerts,
            children: [{
                path: '',
                component: SolicitacaoAnalise,
                meta: { onlyAuthenticated: true }
            }]
        },
        {
            path: '/solicitacao-negada',
            component: LoanAlerts,
            children: [{
                path: '',
                component: SolicitacaoNegada

            }]
        },
        {
            path: '/tipo-de-emprestimo',
            component: AdditionalLoansLayout,
            name: 'tipo-de-emprestimo',
            meta: { onlyAuthenticated: true },
            children: [{
                    path: '',
                    component: SelectLoan
                },
                {
                    path: 'simulacao',
                    name: 'simulacao',
                    component: Simulation
                },
                {
                    path: 'simulacao-emprestimo',
                    name: 'simulacao-emprestimo',
                    component: LoanSimulation
                },
                {
                    path: 'solicitar-emprestimo',
                    name: 'solicitar-emprestimo',
                    component: LoanSolicitationBeta

                }
            ]
        },
        {
            path: '/parceiros',
            component: PartnersLayout,
            children: [{
                path: 'cadastro-investidor',
                component: AdditionalInformationInvestor
            }]
        },
        {
            path: '/preview/:id',
            component: CompanyProfile,
            meta: { onlyAuthenticated: true }
        },
        {
            path: '/',
            component: ApplicationLayout,
            children: [{
                path: '',
                component: HomeInvestor,
                meta: { onlyAuthenticated: true }
            }]
        },
        {
            path: '*',
            component: NotFound
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.query.auth_token) {
        router.app.$store.dispatch('loginWithToken', { token: to.query.auth_token })
        return next({ path: to.path })
    }
    if (to.matched.some(record => record.meta.onlyAuthenticated) && !router.app.$store.state.isLoggedIn) {
        return next({
            path: '/login',
            query: { redirected_from: to.fullPath }
        })
    } else if (to.matched.some(record => record.meta.onlyNotAuthenticated) && router.app.$store.state.isLoggedIn) {
        return next({ path: '/' })
    }

    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js